chat:
  message:
    character-name:
      airi: AIRI
      core-system: Système central
      you: Vous
message: Dites quelque chose...
operations:
  load-models: Charger les modèles
  load-models-status:
    loading: Chargement
    ready: Prêt
select-a-audio-input: Sélectionner une entrée audio
select-a-model: Sélectionner un modèle
select-a-voice: Choisir une voix
viewers:
  debug-menu:
    emotions: Émotions
    emotions-btn:
      angry: '😠 En colère'
      awkward: '😳 Mal à l’aise'
      happy: '😄 Heureux'
      neutral: '🙂 Neutre'
      question: '🤔 Interrogatif'
      sad: '😫 Triste'
      surprised: '🤯 Surpris'
      think: '🤨 Pensif'
    vrm:
      camera: Caméra
      model:
        title: Modèle
waiting: En attente
